import { Component, Inject } from '@angular/core';
import { MODAL_DATA, NgbActiveModal } from '@agilent/ui-element';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-launch-systems-access-dialog',
    styles: [
        `
            :host .inline-progress > ::ng-deep .loader-overlay {
                background: transparent !important;
                margin: 0;
                padding: 0;
                position: static;
                transform: scale(0.7);
            }

            .progress-text {
                color: var(--agilent-magenta);
                font-weight: 600;
            }

            .action-btn {
                width: 7rem;
            }
        `
    ],
    template: `
        <ag-dialog [header]="dialogTitle">
            <ag-dialog-content>
                <table class="table table-borderless">
                    <tbody>
                    <tr>
                        <td colspan="2">
                            <app-user-reason-form
                                [label]="'Reason/description for this change'"
                                [maxlength]="255"
                                [disabled]="isLoading"
                                [class.disabled]="isLoading"
                                (formReady)="formIsReady($event)"></app-user-reason-form>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <button
                                id="action-launch-local"
                                class="action-btn ag-btn-primary"
                                [disabled]="isLaunchButtonDiabled()"
                                [class.disabled]="isLaunchButtonDiabled()"
                                (click)="launchAccess('local')">Local
                                </button>
                        </td>
                        <td>
                            Click on Local if you are connected to the same
                            corporate
                            network as the CID you want to access. <span
                            class="font-weight-bold">(Recommended)</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <button
                                id="action-launch-remote"
                                class="action-btn ag-btn-primary"
                                [disabled]="isLaunchButtonDiabled()"
                                [class.disabled]="isLaunchButtonDiabled()"
                                (click)="launchAccess('remote')">Remote
                                </button>
                        </td>
                        <td>
                            Click on Remote if you are NOT connected to the same
                            corporate
                            network as the CID you want to access.
                            You must have an internet connection for this to
                            work.
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p *ngIf="warningMessage">
                    <span class="font-weight-bold">WARNING:</span>
                    {{ warningMessage }}
                </p>
            </ag-dialog-content>
            <ag-dialog-actions>
                <span *ngIf="isLoading "
                      class="progress-text">Please wait...</span>
                <ag-loader id="loading-spinner" class="inline-progress"
                           [visible]="isLoading " [small]="true"></ag-loader>
                <ag-button
                    type="secondary"
                    [disabled]="isLoading"
                    [class.disabled]="isLoading"
                    (click)="close()"
                    value="Close"
                    id="close-btn"
                ></ag-button>
            </ag-dialog-actions>
        </ag-dialog>
    `
})
export class LaunchSystemsAccessDialogComponent {
    dialogTitle: string;
    task: any;
    taskArgs: any[];
    isLoading = false;
    warningMessage: string;
    reasonForm: FormGroup;

    constructor(
        private activeModal: NgbActiveModal,
        @Inject(MODAL_DATA) private modalData: any
    ) {
        this.task = modalData.task;
        this.taskArgs = modalData.taskArgs;
        this.dialogTitle = modalData.dialogTitle;
        this.warningMessage = modalData.warningMessage;
    }

    async launchAccess(accessType) {
        this.isLoading = true;
        this.taskArgs.push(accessType);
        this.taskArgs.push(this.reasonForm.controls['userReason'].value);
        await this.task.call(this, ...this.taskArgs);
        this.activeModal.close();
    }

    close() {
        this.activeModal.dismiss();
    }

    formIsReady(reasonForm: FormGroup) {
        this.reasonForm = reasonForm;
    }

    isLaunchButtonDiabled() {
        return (
            !this.reasonForm.dirty ||
            this.reasonForm.invalid ||
            this.isLoading
        );
    }
}
